import { Button, Input, message } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { adminApi, AdminLoginRequest } from "../services/api";
import { useAuth } from "../hooks/useAuth";


const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const loginMutation = useMutation({
    mutationFn: (credentials: AdminLoginRequest) => adminApi.login(credentials),
    onSuccess: (data) => {
    
      if (data.success) {
        message.success(data.message || "Login successful!");
        // Use the login function from useAuth hook
        const token = data.data?.token || data.token;
        if (token) {
         
          login(token);
          // Small delay to ensure auth state is updated
          setTimeout(() => {
        
            navigate("/dashboard", { replace: true });
          }, 100);
        } else {
         ""
        }
      } else {
        message.error(data.message || "Login failed");
      }
    },
    onError: (error: any) => {
      console.error("Login error:", error);
      message.error(
        error.response?.data?.message || 
        error.message || 
        "An error occurred during login"
      );
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password) {
      loginMutation.mutate({ email, password });
    } else {
      message.warning("Please fill in all fields");
    }
  };

  return (
    <div className="min-h-full flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
     
      <div className="max-w-md w-full space-y-8 rounded-[12px] border border-[#EAECF0] bg-white shadom-sm p-4">
        <div>
          <h2 className=" text-center text-2xl font-semibold text-gray-900">
            Welcome back
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Enter your credentials to access the admin dashboard
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <label
                htmlFor="email"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Email address
              </label>
              <Input
                placeholder="Email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-[44px] rounded-md border border-gray-300 focus-glow"
                type="email"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label
                htmlFor="password"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Password
              </label>
              <Input
                id="password"
                name="password"
                type="password"
                required
                className="h-[44px] rounded-md border border-gray-300 focus-glow"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <Button 
              htmlType="submit"
              loading={loginMutation.isPending}
              disabled={loginMutation.isPending}
              className="group relative w-full flex justify-center h-[45px] border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50"
            >
              {loginMutation.isPending ? "Signing in..." : "Sign in"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
